module.exports = __webpack_public_path__ + "img/TRASH.a14722be.svg";